/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactECharts from "echarts-for-react";
import { getRegionalanalyseResult } from "../../selectors/widget.js";
import Block from "../Block";
import { round } from "lodash";
import { useCityIndexes } from "../../hooks/useProcessedCityIndexes.js";

const Graph = ({ module }) => {
  const { dataset, cityIndexes, series, valueType, axisLabelFormat } = module;
  const apiResult = useSelector((state) => getRegionalanalyseResult(state, dataset));
  const [mergedOptions, setMergedOptions] = useState(null);

  const [filteredDataset, setFilteredDataset] = useState(null);
  const cityIndexArray = useCityIndexes(cityIndexes);

  useEffect(() => {
    if (apiResult && cityIndexArray.length > 0) {
      let result = apiResult;
      let filtered = result.response.filter(
        (item) => cityIndexArray.includes(item.nr) && item.aar.toString().length <= 4
      );
      setFilteredDataset(filtered);
    }
  }, [apiResult, cityIndexArray]);

  useEffect(() => {
    if (filteredDataset) {
      let data = filteredDataset.sort((a, b) => (a.aar > b.aar ? 1 : -1));

      let minValue = null;
      let maxValue = null;

      let seriesData = series.map((item) => {
        if (valueType === "percentage") {
          data = data.map((i) => {
            return {
              ...i,
              [item.value]: i[item.value] * 100,
            };
          });
        }
        if (item.type === "bar") {
          if (minValue === null) {
            minValue = Math.min(...data.map((i) => round(i[item.value], 2)));
          } else {
            let min = Math.min(...data.map((i) => round(i[item.value], 2)));
            if (minValue > min) {
              minValue = min;
            }
          }

          if (maxValue === null) {
            maxValue = Math.max(...data.map((i) => round(i[item.value], 2)));
          } else {
            let max = Math.max(...data.map((i) => round(i[item.value], 2)));
            if (maxValue < max) {
              maxValue = max;
            }
          }

          return {
            name: item.label,
            type: "bar",
            stack: "total",
            data: data.map((i) => {
              return {
                value: round(i[item.value], 2),
              };
            }),
            emphasis: {
              focus: "series",
            },
          };
        }
        return {
          name: item.label,
          type: "line",
          data: data.map((i) => round(i[item.value], 2)),
          lineStyle: {
            width: 5,
          },
          emphasis: {
            focus: "series",
          },
        };
      });

      let labels = data.map((item) => item.aar);

      let nObj = {
        ...JSON.parse(options),
        tooltip: {
          trigger: "axis",
        },
        color: ["black", "#38c092", "#fa484a", "#ffdcb7"],
        legend: {},
        xAxis: {
          type: "category",
          data: labels,
        },
        yAxis: {
          type: "value",
          min: caclulateBuffer(minValue, valueType, "-"),
          max: caclulateBuffer(maxValue, valueType),
        },
        series: seriesData,
      };
      if (valueType === "percentage") {
        nObj.tooltip.formatter = function (params) {
          let tooltip = `${params[0].name} <br/>`;
          params.forEach((item) => {
            tooltip += `${item.marker} ${item.seriesName}: ${item.value}% <br/>`;
          });
          return tooltip;
        };
      }
      if (axisLabelFormat) {
        if (axisLabelFormat === "percentage") {
          nObj.yAxis.axisLabel = {
            formatter: function (value) {
              return value + "%";
            },
          };
        }
      }

      setMergedOptions(nObj);
    }
  }, [filteredDataset]);

  if (!apiResult) return <p>Mangler data fra SSB</p>;
  if (mergedOptions) {
    return (
      <Block>
        <ReactECharts option={mergedOptions} style={{ marginTop: "20px", height: "700px" }} />
      </Block>
    );
  }

  return null;
};
export default Graph;

const options = JSON.stringify({
  grid: { top: 40, right: 10, bottom: 10, left: 40, containLabel: true },
  // xAxis: {
  //   type: 'category',
  //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  // },
  yAxis: {
    type: "value",
  },
  // series: [
  //   {
  //     data: [820, 932, 901, 934, 1290, 1330, 1320],
  //     type: 'line',
  //     smooth: true,
  //   },
  // ],
  tooltip: {
    trigger: "item",
    formatter: `{c}%`,
  },
});

const caclulateBuffer = (number, valueType, operator) => {
  if (valueType === "percentage") {
    if (operator === "-") {
      return Math.ceil(round(number - 1, 2));
    }
    return Math.ceil(round(number + 1, 2));
  }
  let buffer = 0;
  if (number < 0) {
    buffer = 200;
  }
  if (number > 10 && number <= 200) {
    buffer = 10;
  } else if (number > 200 && number <= 500) {
    buffer = 50;
  } else if (number > 500 && number <= 1000) {
    buffer = 200;
  } else if (number > 1000) {
    buffer = 1000;
  }
  if (operator === "-") {
    return Math.ceil(round((number - buffer) / 100) * 100);
  }
  return Math.floor(round((number + buffer) / 100) * 100);
};
